import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard/admin-dashboard.component';
import { AdminRootComponent } from './admin-root/admin-root.component';
import { SettingsComponent } from './admin-root/settings/settings.component';
import { CanDeactivateGuard } from './core/dirty-tracking/dirty-tracking.guard';
import { EntityMgmtComponent } from './entities/entity-mgmt/entity-mgmt.component';
import { EntityTreeComponent } from './entities/entity-tree/entity-tree.component';
import { LandingRootComponent } from './landing-root/landing-root.component';
import { LoginRootComponent } from './login-root/login-root.component';
import { SetPasswordComponent } from './login-root/set-password.component';
import { OrderManagementComponent } from './orders/order-management/order-management.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { VendorDetailComponent } from './vendors/vendor-detail/vendor-detail.component';
import { VendorListComponent } from './vendors/vendor-list/vendor-list.component';

export class MenuBar {
  constructor() {
    this.isOverlay = false;
  }

  highlighted: string;
  isOverlay: boolean;
}

const routes: Routes = [
  { path: 'login/:resetId', component: SetPasswordComponent },
  { path: 'login', component: LoginRootComponent },
  {
    path: 'manage', component: AdminRootComponent, children: [
      { path: 'users', component: UserListComponent, data: { highlighted: 'users' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'dashboard', component: AdminDashboardComponent, data: { highlighted: 'dashboard' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'settings', component: SettingsComponent, data: { highlighted: 'settings' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'entity-mgmt/:entityId/:tab', component: EntityMgmtComponent, data: { highlighted: 'entities', isOverlay: true }, canDeactivate: [CanDeactivateGuard] },
      { path: 'entity-mgmt/:entityId', component: EntityMgmtComponent, data: { highlighted: 'entities', isOverlay: true }, canDeactivate: [CanDeactivateGuard] },
      {
        path: 'entities', data: { highlighted: 'entities', isOverlay: true }, children: [
          { path: '**', component: EntityTreeComponent, canDeactivate: [CanDeactivateGuard] }
        ]
      },
      { path: 'vendors', component: VendorListComponent, data: { highlighted: 'vendors' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'vendor/:vendorId/:tab', component: VendorDetailComponent, data: { highlighted: 'vendors' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'vendor/:vendorId', component: VendorDetailComponent, data: { highlighted: 'vendors' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'vendor', component: VendorDetailComponent, data: { highlighted: 'vendors' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'orders/:orderId', component: OrderManagementComponent, data: { highlighted: 'orders' }, canDeactivate: [CanDeactivateGuard] },
      { path: 'orders', component: OrderManagementComponent, data: { highlighted: 'orders' }, canDeactivate: [CanDeactivateGuard] },
      { path: '**', component: AdminDashboardComponent, data: { highlighted: 'dashboard' } }
    ]
  },
  { path: '**', redirectTo: 'manage' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
